import React from "react";
import { observer } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

export const CalendarPage: React.FC = observer(() => {
  const navigate = useNavigate();
  return (
    <div className="h-full overflow-y-auto">
      <div className="p-4">
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Calendar</h1>

        <button
          onClick={() => {
            navigate("/plugin-not-found");
          }}
        >
          plugin-not-found
        </button>

        <div className="bg-white rounded-xl p-8 text-center">
          <div className="text-6xl mb-4">📅</div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Calendar View
          </h2>
          <p className="text-gray-500">
            Calendar functionality coming soon. View and manage your scheduled
            orders and reservations.
          </p>
        </div>
      </div>
    </div>
  );
});
